import Vue from "vue";
import VueRouter from "vue-router";
import { store } from "./store.js";

import NotFound from "./pages/NotFound.vue";
import ComingSoon from "./pages/ComingSoon.vue";

import Home from "./pages/Home.vue";
import Signup from "./pages/Signup.vue";
import Signin from "./pages/Signin.vue";
import Incoming from "./pages/Incoming.vue";
import ForgotPassword from "./pages/ForgotPassword.vue";
import ResetPassword from "./pages/ResetPassword.vue";
import Activate from "./pages/Activate.vue";
import VerifyMobile from "./pages/VerifyMobile.vue";
import VerifyLead from "./pages/VerifyLead";

import Privacy from "./pages/Privacy.vue";
import Terms from "./pages/Terms.vue";
import Contact from "./pages/Contact.vue";
import Professionals from "./pages/Professionals.vue";
import Pricing from "./pages/Pricing.vue";
import Clients from "./pages/Clients.vue";
import WhoAreWe from "./pages/WhoAreWe.vue";
import Level1 from "./pages/Level1.vue";
import RealEstate from "./pages/RealEstate.vue";
import CreditoHabitacao from "./pages/CreditoHabitacao.vue";
import PublicProfile from "./pages/PublicProfile.vue";

import { group1 } from "./plugins/serviceList";
import { group2 } from "./plugins/serviceList";
import { group3 } from "./plugins/serviceList";
import { group4 } from "./plugins/serviceList";
import { group5 } from "./plugins/serviceList";
import { group6 } from "./plugins/serviceList";

Vue.use(VueRouter);

const routes = [
/*  {
    path: "",
    name: "soon",
    component: ComingSoon,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      logo: "/static/images/layout/logotop.png",
      hidehead: true,
      hidefoot: true
    }
  },*/

  {
    path: "",
    name: "home",
    component: Home,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      logo: "/static/images/layout/logotop.png"
    }
  },

  {
    path: "/sso",
    name: "incoming",
    component: Incoming,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      hidehead: true,
      hidefoot: true,
      logo: "/static/images/layout/logotop.png"
    }
  },

	{
		path: "/m",
		name: "verifymobile",
		component: VerifyMobile,
		meta: {
			requiresAuth: false,
			saveRoute: false,
			hidehead: true,
			hidefoot: true,
		}
	},

    {
		path: "/l",
		name: "verifylead",
		component: VerifyLead,
		meta: {
			requiresAuth: false,
			saveRoute: false,
			hidehead: true,
			hidefoot: true,
		}
	},

  {
    path: "/registo",
    name: "signup",
    component: Signup,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      hidehead: true,
      hidefoot: true
    }
  },
  {
    path: "/login",
    name: "signin",
    component: Signin,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      hidehead: true,
      hidefoot: true
    }
  },
  {
    path: "/redefinir",
    name: "reset",
    component: ResetPassword,
    meta: {
      requiresAuth: false,
      saveRoute: false,
      hidehead: true,
      hidefoot: true
    }
  },
  {
    path: "/esqueci",
    name: "forgot",
    component: ForgotPassword,
    meta: {
      requiresAuth: false,
      saveRoute: false,
      hidehead: true,
      hidefoot: true
    }
  },
  {
    path: "/ativar",
    name: "activate",
    component: Activate,
    meta: {
      requiresAuth: false,
      saveRoute: false,
      hidehead: true,
      hidefoot: true
    }
  },
  {
    path: "/privacidade",
    name: "privacy",
    component: Privacy,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      logo: "/static/images/layout/logotop.png"
    }
  },
  {
    path: "/termos",
    name: "terms",
    component: Terms,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      logo: "/static/images/layout/logotop.png"
    }
  },
  {
    path: "/contacto",
    name: "contact",
    component: Contact,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      logo: "/static/images/layout/logotop.png"
    }
  },
  {
    path: "/profissionais",
    name: "professionals",
    component: Professionals,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      logo: "/static/images/layout/logotop.png"
    }
  },
  {
    path: "/pacotes",
    name: "pricing",
    component: Pricing,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      logo: "/static/images/layout/logotop.png"
    }
  },
  {
    path: "/comofunciona",
    name: "clients",
    component: Clients,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      logo: "/static/images/layout/logotop.png"
    }
  },
  {
    path: "/quemsomos",
    name: "whoarewe",
    component: WhoAreWe,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      logo: "/static/images/layout/logotop.png"
    }
  },
  {
    path: "/imoveis",
    name: "realestate",
    component: RealEstate,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      main: 1,
      title:
        "Quer comprar ou vender a sua casa? <br>As melhores opções estão aqui.",
      categoryName: "Certificação Energética & Inspeções a Edifícios",
      icon: "/images/search_main/ICONImoveis.png",
      logo: "/static/images/layout/LogoBranco.png",
      services: group1,
      banner: "/static/images/imoveis/ImagemTopo.jpg",
      transphead: true
    }
  },
  {
    path: "/certificacao",
    name: "rating",
    component: Level1,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      main: 3,
      title: "Precisa de fazer um certificado ou inspeção? Procure aqui.",
      categoryName: "Certificação Energética & Inspeções a Edifícios",
      icon: "/images/search_main/ICONCertificacao.png",
      logo: "/static/images/layout/LogoBranco.png",
      services: group3,
      banner: "/static/images/level1/CERT_ImageTopo.jpg",
      transphead: true
    }
  },
  {
    path: "/casa",
    name: "improvement",
    component: Level1,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      main: 2,
      title:
        "Vai fazer alguma obra em casa? <br> Os melhores profissionais estão aqui.",
      categoryName: "Casa",
      icon: "/images/search_main/ICONObras.png",
      logo: "/static/images/layout/LogoBranco.png",
      services: group2,
      banner: "/static/images/level1/OBRAS_ImagemTopo.jpg",
      transphead: true
    }
  },
  {
    path: "/aulas",
    name: "classes",
    component: Level1,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      main: 6,
      title:
        "Para aprender ou compreender melhor...<br>Os melhores profissionais estão aqui.",
      categoryName: "Aulas",
      icon: "/images/search_main/ICONAulas.png",
      logo: "/static/images/layout/LogoBranco.png",
      services: group6,
      banner: "/static/images/level1/AULAS_ImagemTopo.jpg",
      transphead: true
    }
  },
  {
    path: "/climatizacao",
    name: "heating",
    component: Level1,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      main: 4,
      title:
        "Quer alguma instalação/manutenção para aquecimento? <br>Os melhores profissionais estão aqui.",
      categoryName: "Climatização",
      icon: "/images/search_main/ICONAquecimento.png",
      logo: "/static/images/layout/LogoBranco.png",
      services: group4,
      banner: "/static/images/level1/AQUECIMENTO_ImagemTopo.jpg",
      transphead: true
    }
  },
  {
    path: "/outros",
    name: "other",
    component: Level1,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      main: 5,
      title:
        "Para os serviços mais diversos...<br> Os melhores profissionais estão aqui.",
      categoryName: "Outros",
      icon: "/images/search_main/ICONOutros.png",
      logo: "/static/images/layout/LogoBranco.png",
      services: group5,
      banner: "/static/images/level1/OUTROS_ImagemTopo.jpg",
      transphead: true
    }
  },
  {
    path: "/pedido-ch",
    name: "creditohabitacao",
    component: CreditoHabitacao,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      hidehead: true,
      hidefoot: true
    }
  },
  {
    path: "/perfil/:slug",
    name: "public_profile",
    component: PublicProfile,
    meta: {
      requiresAuth: false,
      saveRoute: true,
      logo: "/static/images/layout/logotop.png"
    }
  },
  {
    path: "*",
    component: NotFound,
    name: "not_found",
    meta: {
      hidehead: true,
      hidefoot: true
    }
  }
];

export const router = new VueRouter({
  mode: "history",
  linkActiveClass: "is-active",
  routes,
  store
});

router.beforeEach((to, from, next) => {
  if (
    !store.state.incompleteLeads.data ||
    store.state.incompleteLeads.data.length === 0 ||
    typeof store.state.incompleteLeads.data === "string"
  ) {
    let l = JSON.parse(localStorage.getItem("incompleteLeads"));
    if (l) {
      store.commit("setIncompleteLeads", l);
    }
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem("token")) {
      next({ path: "/login" });
    } else {
      let token = localStorage.getItem("token");
      if (!store.state.token) {
        store.commit("setToken", token);
        //next({path: '/fetch'})
        next();
      } else {
        if (to.meta.saveRoute) {
          localStorage.setItem("route", to.name);
        }
        next();
      }
    }
  } else {
    if (to.meta.saveRoute) {
      localStorage.setItem("route", to.name);
    }
    next();
  }
});



// WEBPACK FOOTER //
// ./src/router.js